export default __webpack_public_path__ + "static/media/video_placeholder.a97e5a73.jpg";